import { Component, HostBinding } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthorizationService } from '../../authorization/authorization.service';

@Component({
  selector: 'app-header',
  template: `
    <app-authenticated-header *ngIf="isAuthenticated$ | async">auth header</app-authenticated-header>
    <app-unauthenticated-header *ngIf="!(isAuthenticated$ | async)">unauth header</app-unauthenticated-header>
  `,
})
export class HeaderComponent {
  public isAuthenticated$: Observable<boolean>;
  @HostBinding('class.site-header') header: boolean = true;

  constructor(_authorizationService: AuthorizationService) {
    this.isAuthenticated$ = _authorizationService.isAuthenticated$;
  }
}
